
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { authApi } from "../../services/authApi";

import "../styles/auth.css";

export default function OnboardingPhone() {
  const nav = useNavigate();

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phone, setPhone] = useState("");
  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);

  const sessionToken =
    sessionStorage.getItem("onb_sessionToken") ||
    localStorage.getItem("onb_sessionToken") ||
    "";

  const fullPhone = `+91${phone}`;

  const sendOtp = async () => {
    if (!firstName.trim()) {
      return alert("Enter First Name");
    }

    if (!lastName.trim()) {
      return alert("Enter Last Name");
    }

    if (phone.length !== 10) {
      return alert("Enter valid 10 digit mobile number");
    }

    setLoading(true);

    try {
      await authApi.sendPhoneOtp(
        fullPhone,
        sessionToken
      );

      alert("OTP sent.");
    } catch (e: any) {
      alert(e.message);
    } finally {
      setLoading(false);
    }
  };

  const verifyOtp = async () => {
    if (phone.length !== 10) {
      return alert("Enter valid 10 digit mobile number");
    }

    if (!otp) {
      return alert("Enter OTP");
    }

    setLoading(true);

    try {
      await authApi.verifyPhoneOtp(
        fullPhone,
        otp,
        sessionToken
      );

      sessionStorage.setItem(
        "onb_phone",
        fullPhone
      );

     
       sessionStorage.setItem(
          "onb_profile",
          JSON.stringify({
            firstName,
            lastName,
            phone: fullPhone,
          })
        );

      nav("/onboarding/password");
    } catch (e: any) {
      alert(e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-wrap">
      <div className="auth-topbar">
        <div
          style={{
            fontWeight: 800,
            color: "#174350",
          }}
        >
          QAVACH
        </div>

        <div style={{ color: "#777" }}>
          Step 1/3
        </div>
      </div>

      <div className="auth-accent">
        Verify Mobile Number
      </div>

      <div className="auth-card">
        <h2 className="auth-title">
          Personal Information
        </h2>

        <p className="auth-sub">
          Enter your details and verify your
          mobile number.
        </p>

        <input
          className="auth-input"
          placeholder="First Name"
          value={firstName}
          onChange={(e) =>
            setFirstName(e.target.value)
          }
        />

        <input
          className="auth-input"
          placeholder="Last Name"
          value={lastName}
          onChange={(e) =>
            setLastName(e.target.value)
          }
        />

        <div
          style={{
            display: "flex",
            alignItems: "center",
            border: "1px solid #dcdcdc",
            borderRadius: "10px",
            marginTop: "10px",
          }}
        >
          <span
            style={{
              padding: "12px",
              background: "#f5f5f5",
              borderRight:
                "1px solid #dcdcdc",
              fontWeight: 600,
            }}
          >
            +91
          </span>

          <input
            className="auth-input"
            style={{
              border: "none",
              marginTop: 0,
            }}
            value={phone}
            maxLength={10}
            placeholder="9876543210"
            onChange={(e) =>
              setPhone(
                e.target.value.replace(
                  /\D/g,
                  ""
                )
              )
            }
          />
        </div>

        <button
          className="auth-btn"
          disabled={loading}
          onClick={sendOtp}
        >
          {loading
            ? "Sending..."
            : "Send OTP"}
        </button>

        <input
          className="auth-input"
          placeholder="Enter OTP"
          value={otp}
          maxLength={6}
          onChange={(e) =>
            setOtp(
              e.target.value.replace(
                /\D/g,
                ""
              )
            )
          }
        />

        <div className="auth-row">
          <button
            className="auth-btn"
            disabled={loading}
            onClick={() =>
              nav("/onboarding")
            }
          >
            Back
          </button>

          <button
            className="auth-btn"
            disabled={loading}
            onClick={verifyOtp}
          >
            {loading
              ? "Verifying..."
              : "Verify OTP"}
          </button>
        </div>
      </div>
    </div>
  );
}